import React from 'react';
import PropTypes from 'prop-types';

export default class FlashWord extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      show: true,
      repetition: this.props.repetition,
    };

    this.showTheWord = this.showTheWord.bind(this);
    this.hideTheWord = this.hideTheWord.bind(this);
  }

  componentDidMount() {
    this.hideTheWord();
  }

  componentWillUnmount() {
    window.clearTimeout(this.hideTheWordTimer);
    window.clearTimeout(this.showTheWordTimer);
  }

  showTheWord() {
    window.clearTimeout(this.hideTheWordTimer);
    this.hideTheWordTimer;

    this.setState({
      show: true,
    }, () => {
      this.hideTheWordTimer = window.setTimeout(this.hideTheWord, this.props.timeShowing);
    });
  }

  hideTheWord() {
    window.clearTimeout(this.showTheWordTimer);
    if(this.state.repetition == 0){
      if(this.props.onEnd){
        this.props.onEnd();
      }

      return;
    }
    this.showTheWordTimer;

    this.setState(({ repetition }) => ({
      show: false,
      repetition: repetition - 1,
    }), () => {
      this.showTheWordTimer = window.setTimeout(this.showTheWord, this.props.timeHidden);
    });
  }

  render() {
    const { className, word } = this.props;
    return this.state.show ? (<span className={className}>{word}</span>) : null;
  }
}

FlashWord.defaultProps = {
  timeShowing: 600,
  timeHidden: 150,
  repetition: 3,
};

FlashWord.propTypes = {
  repetition: PropTypes.number,
  className: PropTypes.string,
  word: PropTypes.string.isRequired,
  onEnd: PropTypes.func,
};